"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function trackUserEvent(userId, name) {
  return (0, _utils.actionCreator)(_types.TRACK_USER_EVENT, {
    userId: userId,
    name: name
  });
}
var _default = exports["default"] = trackUserEvent;